import debounce from "lodash.debounce";
import { useEffect, useMemo, useState } from "react";
import { RxMinus, RxPlus } from "react-icons/rx";

import { Input } from "@sorcery/ui";

export const DeckQuantitySelector = ({
  size = "md",
  quantity,
  onChange,
  doDebounce = true,
  error = false,
}: {
  size?: "sm" | "md";
  quantity: number;
  onChange: (quantity: number) => void;
  doDebounce?: boolean;
  error?: boolean;
}) => {
  const [localQuantity, setLocalQuantity] = useState(quantity);

  useEffect(() => {
    setLocalQuantity(quantity);
  }, [quantity]);

  const debouncedChangeHandler = useMemo(() => debounce(onChange, 1000), [onChange]);

  const changeHandler = useMemo(
    () => (doDebounce ? debouncedChangeHandler : onChange),
    [doDebounce, debouncedChangeHandler, onChange],
  );

  const RightComponent = useMemo(
    () => (
      <div className="flex h-full w-full flex-row items-center justify-end pr-1">
        <div
          onClick={() => {
            setLocalQuantity(localQuantity - 1);
            changeHandler(localQuantity - 1);
          }}
          className={`hover:border-primary flex h-[25px] w-[25px] cursor-pointer select-none flex-col items-center justify-center rounded-full p-1 transition-shadow hover:border hover:shadow-[0_0_18px_rgba(255,123,0,0.9)] 
          ${localQuantity > 0 ? "" : "hidden"}`}
        >
          <RxMinus size={size === "sm" ? 15 : 25} />
        </div>
        <div
          onClick={() => {
            setLocalQuantity(localQuantity + 1);
            changeHandler(localQuantity + 1);
          }}
          className={
            "hover:border-primary flex h-[25px] w-[25px] cursor-pointer select-none flex-col items-center justify-center rounded-full p-1 transition-shadow hover:border hover:shadow-[0_0_18px_rgba(255,123,0,0.9)]"
          }
        >
          <RxPlus size={size === "sm" ? 15 : 25} />
        </div>
      </div>
    ),
    [localQuantity, size, changeHandler],
  );

  return (
    <div className="">
      <Input
        type="number"
        className={size === "sm" ? "max-w-[5rem]" : "max-w-[5.5rem]"}
        value={localQuantity.toString()}
        onChange={(v) => {
          setLocalQuantity(Number.parseInt(v) ?? 0);
          changeHandler(Number.parseInt(v) ?? 0);
        }}
        size={size}
        error={error}
        RightComponent={RightComponent}
      />
    </div>
  );
};
